// extracted by mini-css-extract-plugin
export default {"root":"FiltersSection_root__W7DPw","filterItem":"FiltersSection_filterItem__fAPAC"};